import { Component, Input, OnInit } from '@angular/core';

import { Course } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { ShoppingCartService } from 'lms-api';

@Component({
  selector: 'app-course-view-list',
  templateUrl: './course-view-list.component.html',
  styleUrls: ['./course-view-list.component.scss']
})
export class CourseViewListComponent implements OnInit {

  @Input() course: Course;

  constructor(public lmsUserService: LmsUserService, public cartService: ShoppingCartService) { }

  ngOnInit() {

  }

  triggerShowCourse() {
    if (this.course.renderOnPage) { return; }
    this.course.renderOnPage = true;
  }

}
